import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import { sdk } from '../../../ClassicSection/corvid/ClassicSection.corvid';

export { sdk };

export default createComponentSDKModel(sdk);
